// Backup 

/*

redProducts = Products which is sold out.
yellowProducts = Products which is in cart but not sold out.
-----------------------------------------------------------------
1. Product -
    A. checking_product-status 
    B. add_to-cart
    C. delete_product-cart

2. get all red products, yellow products -
  A. Update dots in Collection page

3. Reservation List

*/

const apiEndpoints = {
  "globalProductLimit": 'https://api.schallergallery.org/index.php/api/product-count',
  "addingProduct": 'https://api.schallergallery.org/index.php/api/checkProductInCart',
  "productCartPageLoad": 'https://api.schallergallery.org/index.php/api/productCartPageLoad',
  "updateProductOrdered": 'https://api.schallergallery.org/index.php/api/updateProductOrdered',
  "deletedUserSocket": 'ws://35.86.199.189:41234.php',
  "reservationProductList": 'https://api.schallergallery.org/index.php/api/reservation-product-list',
  "updateSessionUserId": 'https://api.schallergallery.org/index.php/api/update-session-user-id',
  "deleteProduct": 'https://api.schallergallery.org/index.php/api/delete-product'
};

const apiKey = '9NVw9WDP?QK%jDG';
let userId, soldProducts = [], myCartList = [], yellowProducts = [], redProducts = [], globalProductLimit,
apiHeader = {
  "Content-Type": "application/json",
  "api_key": apiKey
},
progressBar = $('div.progress-bar__progress');
const green = ['progress-bar__progress progress-bar__progress_green', 'Cart Reservation - Active'],
yellow = ['progress-bar__progress progress-bar__progress_yellow', 'Cart Reservation - Active'],
red = ['progress-bar__progress progress-bar__progress_red', 'Cart Reservation - Running Out'],
lost = ['progress-bar__progress progress-bar__progress_lost', 'Cart Reservation - Lost'];

if (localStorage.getItem("globalProductLimit")) {
  let globalProductLimitVar = localStorage.getItem('globalProductLimit');
  globalProductLimit = globalProductLimitVar;
} else {
  globalProductLimit = 0;
}

localStorage.setItem('globalProductLimit', globalProductLimit);

// Global set time out varibels
window.cartTimer = {
  isTimerOn: false,
  timerId: 0
}
window.cartTimer.isTimerOn =  localStorage.getItem('isTimerOn') == null ? localStorage.getItem('isTimerOn') : false; 
window.cartTimer.timerId = localStorage.getItem('timerId') == null ? localStorage.getItem('timerId') : 0;
localStorage.setItem('isTimerOn',window.cartTimer.isTimerOn);
localStorage.setItem('timerId',window.cartTimer.timerId);

// utility function
async function updateUserId(account_id){
  //console.log('updateUserId');
  //console.log(account_id);
  console.log(userId);
  const userIDs = {
    "user_session_id": userId,
    "user_id": account_id
  };
  try {
    const response = await fetch(`${apiEndpoints['updateSessionUserId']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(userIDs)
    });
    const data = await response.json();
    //console.log(data);
    userId = account_id;
  } catch (error) {
    console.error('Something went wrong - ' +error);  
  }
}

function uniqueUserId(account_id) {
  // Declare userId at the top
  userId = localStorage.getItem("ct-cart-id");
  //console.log(account_id);

  if (userId) {
    //console.log(userId);
    // Check if account_id is provided and not the same as the current userId
    if (account_id !== undefined && account_id !== '' && userId !== account_id) {
     // console.log(account_id);
      updateUserId(account_id);
      // Update the local storage with the new userId
      localStorage.setItem("ct-cart-id", account_id);
    } else {
      console.log('User not logged in or account_id is the same as the current userId.');
    }
  } else {
    // If there's no userId in localStorage
    if (account_id !== undefined && account_id !== '') {
      userId = account_id;
    } else {
      // Generate a new userId if account_id is not provided
      userId = 'CT' + (Math.random() + 1).toString(36).substring(3);
    }
    // Store the userId in localStorage
    localStorage.setItem("ct-cart-id", userId);
    //console.log(userId);
  }
}


async function setGlobalProductLimit() {
  console.log('setGlobalProductLimit API call');
  //console.log(userId);
  const userID = {
    "user_id": userId
  };
  try {
    const response = await fetch(`${apiEndpoints['globalProductLimit']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(userID)
    });
    const data = await response.json();
   // console.log(data);
    globalProductLimit = data.product_count;
    localStorage.setItem('globalProductLimit', globalProductLimit);
    if (window.location.href.indexOf("cart") > -1) {
        $('div.cartHeader__group p span')[0].innerHTML = data.product_count;
    }
  } catch (error) {
    console.log("catch...");
    $(".product-add-btn-cart").attr("disabled",false);
    console.error('Something went wrong - ' +error);  
  }
}


async function reservation_removeCall(event){
  let reserv_id = event.target.parentNode.getAttribute('data-reserv_id');
  //console.log(reserv_id);

  const delete_ProductQuery = {
    "product_id": reserv_id,
    "user_id": userId
  }
  try {
    const response = await fetch(`${apiEndpoints['deleteProduct']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(delete_ProductQuery)
    });
    if (response.ok) {
      const removeButton = event.target;
      const parentWrapper = removeButton.parentNode;
      const grandparentNode = parentWrapper.parentNode.parentNode;
      grandparentNode.parentNode.removeChild(grandparentNode);
    }
  } catch (error) {
    console.error('Something went wrong - ' +error);  
  }
}

async function handleRemoveButtonReservation() {
  const removeButtons = document.querySelectorAll('.cart-item_remove-wrapper.reservation_remove-item');
  removeButtons.forEach((button) => {
    button.addEventListener('click', (event)=>{
      reservation_removeCall(event);
    });
  });
}

/* ===================================
Cart reservation
====================================== */

function startTimer(timeLimit = 900000) {
  // Explicitly stop any ongoing timer
  if (window.cartTimer.timerId) {
    clearTimeout(window.cartTimer.timerId);
    window.cartTimer.isTimerOn = false;
  }

  console.warn("TIMER STARTED");
  startProgressInterval(15 - (timeLimit / 1000 / 60));

  // Start a new timer
  window.cartTimer.timerId = setTimeout(() => {
    //clear the bar
    let data = lost;
    progressBar.removeClass();
    progressBar.addClass(data[0]);
    document.querySelector('.progress-bar-container .progress-bar__heading span').style.color="#fff";
    $('div.progress-bar__heading span').html(data[1]);
    
    //console.warn("EMPTY CART");
   // console.log("EMPTY CART.......");
    var currentTime = 15 - (timeLimit / 1000 / 60);
    setTimeout(function() {
          window.location.reload();
          //console.log("Reloading page after EMPTY CART finished...."+currentTime);
      }, 10000); 
    clearCartTimeout();
    window.cartTimer.isTimerOn = false;
  }, timeLimit);

  window.cartTimer.isTimerOn = true;
  // Update localStorage or any persistent state if necessary
}

/* Progressbar */
const totalMinutes = 15;
const totalMilliseconds = totalMinutes * 60 * 1000;
function updateProgressBar(currentMinute) {
    //Calculate the start time based on the current minute passed into the function
    let startTime = performance.now() - currentMinute * 60000;
    function renderFrame() {
        const now = performance.now();
        const elapsedMilliseconds = now - startTime;
        const remainingMilliseconds = totalMilliseconds - elapsedMilliseconds;
        const reversePercentage = (remainingMilliseconds / totalMilliseconds) * 100;
        const seconds = Math.floor((elapsedMilliseconds / 1000) % 60); // Calculate seconds
        const minutes = Math.floor(elapsedMilliseconds / 60000); // Calculate full minutes
        // Log the seconds and minutes for debugging
        //console.log(`Elapsed Time - Minutes: ${minutes}, Seconds: ${seconds}`);
        $('.progress-bar__progress').css('width', `${reversePercentage.toFixed(2)}%`);
        if (elapsedMilliseconds < totalMilliseconds) {
            requestAnimationFrame(renderFrame); // Continue to update
        } else {
            console.log("Timer complete.");
            $('.progress-bar__progress').css('width', '0%'); // Ensure it visually ends at 0%
        }
    }
    requestAnimationFrame(renderFrame);
}

/* Progressbar end */ 


function startProgressInterval(progressTime=0){  
  // Assuming window.cartTimer.progressIntervalId is initialized somewhere globally
  // Clear any existing progress interval before starting a new one
  if(window.cartTimer.progressIntervalId) {
    clearInterval(window.cartTimer.progressIntervalId);
  }
  console.log("Initial progressTime "+progressTime);
 updateProgressBar(progressTime); 
  refresh_reservationBar(progressTime); // Initial call to set the progress bar based on the current progressTime

    // Start a new progress interval and store its ID for potential future clearance
  window.cartTimer.progressIntervalId = setInterval(() => {
    progressTime += 1; // Increment progressTime first to ensure it's updated for the current interval tick
    refresh_reservationBar(progressTime);
    console.log("progressTime "+progressTime);
    if(progressTime == 14){
      clearInterval(window.cartTimer.progressIntervalId); // Clear the interval once progress is complete
    }
  }, 60000); // Run every minute
}
function refresh_reservationBar(progressTime) {
  console.log("refresh reservation - "+progressTime);
  if (progressTime < 7) {
    console.log(progressTime);
    let data = green;
    progressBar.removeClass();
    progressBar.addClass(data[0]);
    $('div.progress-bar__heading span').html(data[1]);
    document.querySelector('.progress-bar-container .progress-bar__heading span').style.color="#090909";
  } else if (progressTime < 13) {
    //console.log(progressTime);
    let data = yellow;
    progressBar.removeClass();
    progressBar.addClass(data[0]);
    document.querySelector('.progress-bar-container .progress-bar__heading span').style.color="#090909";
    $('div.progress-bar__heading span').html(data[1]);
  } else if (progressTime < 14) {
    //console.log(progressTime);
    let data = red;
    progressBar.removeClass();
    progressBar.addClass(data[0]);
    document.querySelector('.progress-bar-container .progress-bar__heading span').style.color="#fff";
    $('div.progress-bar__heading span').html(data[1]);
  }
}

function getTimerMinutes(latest_timestamp){
  // Get the current UTC time
  const currentUtcTime = new Date().toISOString();

  // Parse the latest_timestamp and currentUtcTime into Date objects
  const latestTime = new Date(latest_timestamp.replace(' ', 'T') + 'Z');
  const currentTime = new Date(currentUtcTime);

  // Calculate the time difference in minutes
  const timeDifferenceInMinutes = Math.floor((currentTime - latestTime) / (1000 * 60));
  //console.log(timeDifferenceInMinutes);
  //console.log("timeDifferenceInMinutes - "+timeDifferenceInMinutes);
  const seconds = (15 - timeDifferenceInMinutes) * 60 * 1000;
  //console.log(seconds);
  //console.log("seconds - "+seconds);
  startTimer(seconds)
}

/* ===================================
Cart buttons Controller
====================================== */
function cartButtonsController() {
  const $container = $('.product-buy-container').first();
  if (!$container.length) return;

  const $add_to_cartBtn = $container.find('button.product-add-btn-cart').first();
  const $btnText = $add_to_cartBtn.find('.product-add-btn-text').first();
  const $productStatusIndicator = $container.find('span.product-status__timer').first();

  if (!$add_to_cartBtn.length || !$btnText.length || !$productStatusIndicator.length) return;

  // Button Text
  // const buttonTextDefault = 'Add to cart';
  // const buttonTextGreen = 'Item reserved and added to cart';
  // const buttonTextYellow = 'Sorry, item is currently reserved';
  // const buttonTextRed = 'Sold';
  // const buttonTextLimit = 'Limit reached';

  const buttonTextDefault = 'Add to cart';
  const buttonTextGreen = 'Add to cart';
  const buttonTextYellow = 'Add to cart';
  const buttonTextRed = 'Add to cart';
  const buttonTextLimit = 'Add to cart';

  // Message Status
  // const productStatusGreen = ['Item is in your cart.', 'product-status__timer product-status__timer-green'];
  // const productStatusYellow = ['Reserved', 'product-status__timer product-status__timer-yellow'];
  // const productStatusRed = ['Item has been sold.', 'product-status__timer product-status__timer-red'];
  // const productStatusLimit = ['You exceeded the 6 item limit.', 'product-status__timer product-status__timer-red'];

  const productStatusGreen = ['', 'product-status__timer product-status__timer-green'];
  const productStatusYellow = ['', 'product-status__timer product-status__timer-yellow'];
  const productStatusRed = ['', 'product-status__timer product-status__timer-red'];
  const productStatusLimit = ['', 'product-status__timer product-status__timer-red'];

  // 1) HARD STOP: If Shopify says it is sold out, never override with "Add to cart"
  const isSoldOutByLiquid =
    $add_to_cartBtn.hasClass('sold-out') ||
    $add_to_cartBtn.is(':disabled') ||
    ($container.find('input[name="product_is_soldout"]').val() === 'true');

  if (isSoldOutByLiquid) {
    $productStatusIndicator.removeClass().addClass(productStatusRed[1]).html(productStatusRed[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextRed);
    return;
  }

  // Remaining logic depends on your global arrays.
  // If they are not ready yet, do NOT change anything.
  if (typeof myCartList === 'undefined' || typeof yellowProducts === 'undefined' || typeof soldProducts === 'undefined') {
    return;
  }

  const $currentProduct = $container.find('button[data-pid]').first();
  if (!$currentProduct.length) return;

  const item_id = String($currentProduct.attr('data-pid') || '');

  // Default: disable until we decide
  $add_to_cartBtn.attr('disabled', true);

  const inCart = myCartList.includes(item_id);
  const isReserved = yellowProducts.includes(item_id);
  const isSoldByLists = soldProducts.includes(item_id);

  // If your sold list has it (extra safety)
  if (isSoldByLists) {
    $productStatusIndicator.removeClass().addClass(productStatusRed[1]).html(productStatusRed[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextRed);
    return;
  }

  // Not in any list
  if (!inCart && !isReserved) {
    const globalProductLimitVar = Number(localStorage.getItem('globalProductLimit') || 0);

    if (globalProductLimitVar < 6) {
      $productStatusIndicator.html('');
      $add_to_cartBtn.removeAttr('disabled');
      $btnText.text(buttonTextDefault);
    } else {
      $productStatusIndicator.removeClass().addClass(productStatusLimit[1]).html(productStatusLimit[0]);
      $add_to_cartBtn.attr('disabled', true);
      $btnText.text(buttonTextLimit);
    }

    return;
  }

  // In cart
  if (inCart) {
    $productStatusIndicator.removeClass().addClass(productStatusGreen[1]).html(productStatusGreen[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextGreen);
    return;
  }

  // Reserved
  if (isReserved) {
    $productStatusIndicator.removeClass().addClass(productStatusYellow[1]).html(productStatusYellow[0]);
    $add_to_cartBtn.attr('disabled', true);
    $btnText.text(buttonTextYellow);
    return;
  }
}

/* ===================================
refreshMyCart - update myCartList[]
cartRefreshYellowRedCart - update yellow and red product array.
cartRefreshBadges -
====================================== */

function refreshMyCart(data) {
  //console.log('refreshMyCart fun run ___');
  if(data && data.product_id){
    let productsID = data.product_id;
    myCartList = [];
    let data_count = data.product_id.length - 1;
    let latest_timestamp = data.product_id[data_count].created_date;
   // console.log('latest_timestamp '+latest_timestamp);
    getTimerMinutes(latest_timestamp);
   // console.log(latest_timestamp);
    if(Array.isArray(data.product_id)){
      for(let i = 0; i < productsID.length; i++) {
        const product_id_ele = productsID[i];
        if (!myCartList.includes(product_id_ele.product_id)) {
          myCartList.push(product_id_ele.product_id);
        }
      }
    }
  } else {
    clearCartTimeout();
  }
}

function cartRefreshYellowRedCart(data, update_status_btn) {
  // Yellow products
  console.log("cartRefreshYellowRedCart - - "+data.product_id);
  let yellowProductsID = data.product_id;
  yellowProducts = [];
  
  if (yellowProductsID && Array.isArray(yellowProductsID)) {
    for (let i = 0; i < yellowProductsID.length; i++) {
      const product_id_ele = yellowProductsID[i];
      if (!yellowProducts.includes(product_id_ele.product_id)) {
        yellowProducts.push(product_id_ele.product_id);
      }
    }
  }
  
  // Red products
  let redPoductsID = data.product_ordered_id;
  redProducts = [];
  if (redPoductsID && Array.isArray(redPoductsID)) {
    for (let i = 0; i < redPoductsID.length; i++) {
      const product_id_ele = redPoductsID[i];
      if (!redProducts.includes(product_id_ele)) {
        redProducts.push(product_id_ele);
      }
    }
  }
  if (update_status_btn === 'true') {
    console.log('btn control run');
    cartButtonsController();
  }
}
function cartRefreshBadges() {
  //console.log('cart dots');
  let productsPID = document.querySelectorAll('span.card__into-pid[data-pid]');
  let template_suffix = document.querySelector('[data-template_suffix]').innerHTML;

  if (template_suffix !== 'merchandise-category' || template_suffix == undefined) {
    for (let index = 0; index < productsPID.length; index++) {
      let item = productsPID[index];
      let productsPID_val = item.getAttribute('data-pid');
      let nodeTarget = $(item).parent().find('span.product-status__timer');

      if (yellowProducts.includes(productsPID_val)) {
       // console.log('yellow dot true');
        nodeTarget.removeClass("product-status__timer-red");
        nodeTarget.addClass("product-status__timer-yellow");
      } else if (soldProducts.includes(productsPID_val)) {
       // console.log('red dot true');
        nodeTarget.removeClass("product-status__timer-yellow");
        nodeTarget.addClass("product-status__timer-red");
      }
    }
  }
}

/* ===================================
API calls (two request in one promise)
====================================== */

async function cartFetchAllProductStatus(update_status_btn='false', call_back_function) {
  console.log('Consoele - cartFetchAllProductStatus');
 // console.log(update_status_btn);
  try {
    const userID = {
      "user_session_id": userId
    };

    // Make both API requests concurrently using Promise.all
    let myCart, red_yellowCart;
    if($(".variant-addbtn-container").length > 0 ){
      console.log("variant-addbtn-container --   in");
        var productID = $("input[name='product_id']").val();
            productID = parseInt(productID);
        var newuserId = userId;
        if(userId=="" || userId == undefined || userId == null){
            var newuserId = "abc123xyz";
        }
        const productArr = {
            "user_id": userId,
            "product_id": productID
        };
          [myCart, red_yellowCart] = await Promise.all([
       
        fetch('https://api.schallergallery.org/index.php/api/productCartPageLoad', {
            method: "POST",
            headers: apiHeader,
            body: JSON.stringify(userID)
        }),
        fetch('https://api.schallergallery.org/index.php/api/check-product-in-others-cart', {
            method: "POST",
            headers: apiHeader,
            body: JSON.stringify(productArr)
        })
      ]);
    }else{
      console.log("variant-addbtn-container --   out");
          [myCart, red_yellowCart] = await Promise.all([
        fetch('https://api.schallergallery.org/index.php/api/productCartPageLoad', {
          method: "POST",
          headers: apiHeader,
          body: JSON.stringify(userID)
        }),
        fetch('https://api.schallergallery.org/index.php/api/productCartPageLoad', {
          method: "POST",
          headers: apiHeader
        })
      ]);
    }
    if (myCart.ok && red_yellowCart.ok) {
      const myCart_data = await myCart.json();
      console.log("testing console------------------------");
       console.log(myCart_data);
       console.log("testing console------------------------end");
      refreshMyCart(myCart_data);
  
      const red_yellowCart__data = await red_yellowCart.json();
      console.log("testing console------------------------1");
      console.log(red_yellowCart__data);
      console.log("testing console--------------------1----end");
      cartRefreshYellowRedCart(red_yellowCart__data, update_status_btn);
    } else {
      console.log('One or both API calls failed');
      cartButtonsController();
    }
    
    if (typeof call_back_function === 'function') {
      call_back_function() // Call the callback function after successful API responses
    }
    
  } catch (error) {
    console.error('Error occurred during API call:' + error);
  }
}


/* ===================================
Fetch all products of user
====================================== */

async function cartFetchMyProduct(call_back_function) {
  //console.log('fetch API call');
  const userID = {
    "user_session_id": userId
  };
  try {
    const response = await fetch(`${apiEndpoints['productCartPageLoad']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(userID)
    });
    const data = await response.json();
    refreshMyCart(data);
    if (typeof call_back_function === 'function') {
      call_back_function()
    }
  } catch (error) {
    console.error('Error occurred during API call:' + error);
  }
}

/* ===================================
Add-to-cart product CALL -
====================================== */

async function cartAddToCart(cart_product_id, cart_product_handle, is_sold_out) {
  if(is_sold_out != 'true'){
 // console.warn("cartAddToCart fun run--");
  let status;
  const add_productQuery = {
    "product_id": cart_product_id,
    "product_handler": cart_product_handle,
    "user_session_id": userId
  }
  try {
    const response = await fetch(`${apiEndpoints['addingProduct']}`, {
      method: 'POST',
      headers: apiHeader,
      body: JSON.stringify(add_productQuery)
    });
    const apiResponse = await response.json();
    //console.log(apiResponse.product_id);
    const status = JSON.stringify(apiResponse.status);
   // console.log('add result + ' + !myCartList.includes(cart_product_id));
    if (status === 'true' && !myCartList.includes(cart_product_id)) {
      myCartList.push(cart_product_id);
      ++ globalProductLimit;
      localStorage.setItem("globalProductLimit", globalProductLimit);
     // console.log(globalProductLimit);
      //Start TImer
      startTimer();
    }
    cartButtonsController();
    return status;
  } catch (error) {
    console.error('Error occurred during API call:' + error);
    // Handle the error as needed
  }
  }
}

/* ===================================
cartDeleteProduct (Delete product CALL) - This get called when user delete product by himself from cart page.

====================================== */

async function cartDeleteProduct(cartDelete_product_id) {
  //console.log('delete API call');
  const delete_ProductQuery = {
    "product_id": cartDelete_product_id,
    "user_id": userId
  }
  try {
    const response = await fetch(`${apiEndpoints['deleteProduct']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(delete_ProductQuery)
    });
    if (!response.ok) {
      throw new Error("Failed to delete product");
    }
    const deletedStatus = await response.json();
    
    if(deletedStatus.status == true){
      myCartList.pop(cartDelete_product_id);

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
         // console.log("Total products in cart:", cart.item_count);
          $(".title-wrapper-with-link .cartHeader__group p span").text(cart.item_count);
        })
        .catch(error => console.error("Failed to fetch cart:", error));


      
      let globalProductLimitVar = localStorage.getItem('globalProductLimit') - 1;
      localStorage.setItem('globalProductLimit', globalProductLimitVar);
    }
    return deletedStatus;
  } catch (error) {
    console.error('Something went wrong - ' +error);
  }
}

async function clearCartTimeout(){
    try{
      const request = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    //  console.log("Clearing the cart Request.......");
    //  console.log(request.ok);
      if(request.ok){
     //   console.log("Clearing the cart.......");
        $('#cart-icon-bubble .cart-count-bubble span').html('');
        localStorage.setItem('globalProductLimit', 0);
          //window.location.reload();
      }
      
    } catch(error){
        console.log('Time out cart clear error - ', error);
    }
}

/* ===================================
Reservation product CALL -
- cart_reservation__appenEle: Adding data HTML to page.
- cartFetchReservationProducts: fetch cart reservationProducts list.
- cart_reservationShopifyCall: in this passing ids from first fun to shopify API to get product Data.
====================================== */

function cart_reservation__appenEle(shopify_reservationProductsData, availability_data) {
  if(shopify_reservationProductsData.length >= 0){
    // shopify_reservationProductsData is from shopify API ||| availability_data is our api data which help to know which item is available or not
    let inject_container = document.querySelector('tbody#cart-reservation-container-inject');
    inject_container.innerHTML = '';
    for (var i = 0; i < shopify_reservationProductsData.length; i++) {
      var reservation_id = shopify_reservationProductsData[i];
      if(reservation_id !== null){
        
        let item_url = reservation_id.handle, item_title = reservation_id.title, item_vendor = reservation_id.vendor, item_price = reservation_id.priceRange.minVariantPrice.amount,
          item_img_url = reservation_id.featuredImage.url, item_sku = reservation_id.variants.edges[0].node.sku, item_availability_status, item_availbaility_content = '', item_removeBtn;
        for (var availability_data_item = 0; availability_data_item < availability_data.length; availability_data_item++) {
          var item = availability_data[availability_data_item];
          let reservationId = reservation_id.id.replace(/[^0-9]/g, '');
          if(item.product_id == reservationId){
            //console.log(item.is_product_added);
            item_availability_status = item.is_product_added;
          }
        }
        if (item_availability_status == false) {
          item_availbaility_content =
            `
              <div class="reservation_cart_status-true">
                <span>Still Available</span>
                <a href="/products/${item_url}" class="reservation_cart_status-btn">ADD BACK TO CART?</a>
              </div>
              `;
            item_removeBtn = `
                <div class="cart-item_remove-wrapper reservation_remove-item" data-reserv_id="${reservation_id.id.replace(/[^0-9]/g, '')}">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.044" height="24.935" viewBox="0 0 22.044 24.935"><g id="Trash" transform="translate(0 0)">
                    <path id="Path_235" data-name="Path 235" d="M2.768,3.935H19.407l-1.9,20H4.672Zm-1.1-1,2.1,22H18.412l2.095-22Z" fill="#fff"></path>
                    <rect id="Rectangle_129" data-name="Rectangle 129" width="1" height="13.212" transform="translate(6.882 7.385) rotate(-4.341)" fill="#fff"></rect>
                    <rect id="Rectangle_130" data-name="Rectangle 130" width="13.212" height="1" transform="translate(13.293 20.483) rotate(-85.641)" fill="#fff"></rect>
                    <rect id="Rectangle_131" data-name="Rectangle 131" width="22.044" height="1" transform="translate(0 2.935)" fill="#fff"></rect>
                    <g id="Group_242" data-name="Group 242"><g id="Group_241" data-name="Group 241" clip-path="url(#clip-path)"><path id="Path_236" data-name="Path 236" d="M14.793,3.707h-1a2.707,2.707,0,1,0-5.413,0h-1a3.707,3.707,0,1,1,7.413,0" fill="#fff"></path></g></g>
                </g></svg>
                <span>Remove</span>
              </div>
            `;
        }
         else {
          item_availbaility_content =
            `
              <div class="reservation_cart_status-false">
                <p>No Longer Available</p>
              </div>
              `;
          item_removeBtn = ` <div class="cart-item_remove-wrapper reservation_remove-item" data-reserv_id="${reservation_id.id.replace(/[^0-9]/g, '')}">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.044" height="24.935" viewBox="0 0 22.044 24.935"><g id="Trash" transform="translate(0 0)">
              <path id="Path_235" data-name="Path 235" d="M2.768,3.935H19.407l-1.9,20H4.672Zm-1.1-1,2.1,22H18.412l2.095-22Z" fill="#fff"></path>
              <rect id="Rectangle_129" data-name="Rectangle 129" width="1" height="13.212" transform="translate(6.882 7.385) rotate(-4.341)" fill="#fff"></rect>
              <rect id="Rectangle_130" data-name="Rectangle 130" width="13.212" height="1" transform="translate(13.293 20.483) rotate(-85.641)" fill="#fff"></rect>
              <rect id="Rectangle_131" data-name="Rectangle 131" width="22.044" height="1" transform="translate(0 2.935)" fill="#fff"></rect>
              <g id="Group_242" data-name="Group 242"><g id="Group_241" data-name="Group 241" clip-path="url(#clip-path)"><path id="Path_236" data-name="Path 236" d="M14.793,3.707h-1a2.707,2.707,0,1,0-5.413,0h-1a3.707,3.707,0,1,1,7.413,0" fill="#fff"></path></g></g>
          </g></svg>
          <span>Remove</span>
        </div>`
        }
        let html_template =
          `
          <tr class="cart-item">
          <td class="cart-item__media reservation_cart-media">
            <div class="cart-item__image-container gradient global-media-settings">
              <img src="${item_img_url}" class="cart-item__image" alt=""
                loading="lazy" width="150" height="150">
            </div>
          </td>
          
          <td class="cart-item__details reservation_cart-details">
            <p class="caption-with-letter-spacing">${item_vendor}</p>
            <a href="/products/${item_url}" class="cart-item__name h4 break">${item_title}</a>
            <div class="product-option product-price-cart">
              $${item_price}
            </div>
            ${item_removeBtn}
          </td>
          
          <td class="cart-item__quantity reservation_cart-sku">
            <div class="cart-item__quantity-wrapper">
              ${item_sku}
            </div>
          </td>
  
          <td class="cart-item__details reservation_cart_status-container">
            ${item_availbaility_content}
          </td>
          </tr>
        `;
        inject_container.innerHTML += html_template;
      }
    }
    $('.cart-items.hidden').removeClass('hidden');
        handleRemoveButtonReservation();
  } else{
    $('.page-width.reservation-list').addClass('hidden');
  }
}
async function cartFetchReservationProducts() {
  let availability_data = [], availability_ids = [];
  //console.log('cartFetchReservationProducts API call');
  const reservation_ProductQuery = {
    "user_id": userId
  }
  const Requestreservation_products = await fetch(`${apiEndpoints['reservationProductList']}`, {
      method: "POST",
      headers: apiHeader,
      body: JSON.stringify(reservation_ProductQuery)
  });

  const  reservation_products = await Requestreservation_products.json();
  //pushing availability_data
  //(reservation_products)
  reservation_products.products.forEach(item => {
    availability_ids.push(item.product_id);
    availability_data.push(item);
  });
  if(reservation_products.products.length != 0){
    cart_reservationShopifyCall(availability_ids, availability_data);
  } else{
     $('div.reservation_cart_items#main-cart-items').hide();
  }
}
async function cart_reservationShopifyCall(availability_data_id, availability_data) {
  let productid_q = []; //= ["gid://shopify/Product/7797030846615", "gid://shopify/Product/7797014626455"];
  availability_data_id.forEach(item => {
    let qformate = `gid://shopify/Product/${item}`
    productid_q.push(qformate);
  });
  //console.log(productid_q);
  let productsid_query = JSON.stringify(productid_q);

  const query = () =>
    `{
    nodes(ids: ${productsid_query}) {
    ...on Product{
      featuredImage {
        url
        altText
      }
      id
      title
      handle
      vendor
      variants(first: 1) {
        edges {
          node {
            id
            sku
          }
        }
      }
      priceRange {
        minVariantPrice {
          amount
        }
      }
    }
  }
  }
  `
  const headers = new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Shopify-Storefront-Access-Token": "1f9086356dab346648598593705d2172",
  });
  const response = await fetch('https://schallergallery.myshopify.com//api/2023-01/graphql', {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ query: query() }),
  })
  const Shop = await response.json();
  cart_reservation__appenEle(Shop.data.nodes,availability_data);
}

/* ====================================
Sold Products API endpoint call -- Which call as part of checkout snippet.
====================================== */

function cartProductSold() {
  let is_thankyou_container = document.querySelector('div[data-step="thank_you"]');
  if ((document.documentElement.textContent || document.documentElement.innerText).indexOf('Your order is confirmed') > -1) {
    if (is_thankyou_container != undefined) {
      const apiKey = '9NVw9WDP?QK%jDG';
      let apiHeader = {
        "Content-Type": "application/json",
        "api-key": apiKey
      };

      async function cart_soldoutCall(cart_product_id) {
        //console.log("Async worker is start");
        let status;
        const add_soldProductQuery = {
          "product_id": [cart_product_id]
        };
        await fetch(`${apiEndpoints['updateProductOrdered']}`, {
            method: 'POST',
            headers: apiHeader,
            body: JSON.stringify(add_soldProductQuery)
          })
          .then(response => response.json())
          .then(response => console.log(response))
          .then(data => {
            soldProducts.push(cart_product_id);
          })
      }

      window.addEventListener('load', function () {
        let sold_product_ids = [],
          soldProducts = document.querySelectorAll('tbody[data-order-summary-section] tr.product');
        for (i = 0; i < soldProducts.length; i++) {
          if (soldProducts[i].dataset.productType != 'Merchant') {
            sold_product_ids.push(soldProducts[i].dataset.productId);
          }
        }
       // console.log("Product id - " + sold_product_ids)
        cart_soldoutCall(sold_product_ids)
      });
    }
  }
}

// document.addEventListener("DOMContentLoaded", function(event) { 
//   if (window.location.href.includes("/collection") || !window.location.href.includes("/cart")) {
//     if(!window.location.href.includes("/products")){
//       cartFetchAllProductStatus('false', cartRefreshBadges);
//     }
//   } else if (!window.location.href.includes("/products") || !window.location.href.includes("/cart")) {
//     cartFetchAllProductStatus();
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  var dataAtt = $("body").attr("data-template");
   if(dataAtt=="makers"){
      const grid = document.getElementById('product-grid');
      if (!grid) {
        console.warn('[REORDER] #product-grid not found');
        return;
      }
      
      let observer; // declare globally so we can disconnect/reconnect
      
      function reorderProducts() {
      if (observer) observer.disconnect();
      
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartIds = cart.items.map(i => String(i.product_id));
          const allProducts = Array.from(grid.querySelectorAll('li.grid__item'));
      
          // Use a Set to make sure we don't duplicate
          const seenIds = new Set();
      
          const regularAvailable = [];
          const yellowTimed = [];
          const inCart = [];
          const soldOut = [];
      
          allProducts.forEach(product => {
      const id = String(product.getAttribute('data-product-id') || '').trim();
      const isAvailable = product.getAttribute('data-product-available') === 'true';
      const isInCart = cartIds.includes(id);
      
      // Updated: More reliable check for yellow-timer class
      const hasYellowTimer = Array.from(product.querySelectorAll('*')).some(el =>
        el.classList.contains('product-status__timer-yellow')
      );
      
      if (isAvailable && hasYellowTimer) {
        yellowTimed.push(product); // Yellow timer
      } else if (isAvailable && !isInCart) {
        regularAvailable.push(product); // Normal available
      } else if (isInCart) {
        inCart.push(product); // cart
      } else {
        soldOut.push(product); // 
      }
      });
      
      
          const sorted = [...regularAvailable, ...yellowTimed, ...inCart, ...soldOut];
      
          // Clear existing products before re-adding
          grid.innerHTML = '';
          sorted.forEach(p => grid.appendChild(p));
      
          console.log(`[REORDER] → A:${regularAvailable.length} | Y:${yellowTimed.length} | C:${inCart.length} | S:${soldOut.length}`);
      
          if (observer) observer.observe(grid, { childList: true });
        })
        .catch(err => console.error('[REORDER] cart.js error:', err));
      }
      
      
      
      function startObserving() {
        observer = new MutationObserver((mutations) => {
          if (mutations.some(m => [...m.addedNodes].some(n =>
            n.nodeType === 1 && n.matches?.('li.grid__item')))) {
            console.log('[REORDER] Lazy-loaded products detected');
            reorderProducts(); //  This was previously causing infinite loop
          }
        });
      
        observer.observe(grid, { childList: true });
      }
      
      reorderProducts(); // initial load
      startObserving();  // enable for lazyload
  }
      
});
